module.exports = __webpack_public_path__ + "img/quot.4fc61db1.png";